<div class="s7-container">
    <back-to-registries-button></back-to-registries-button>

    <div class="s7-page-error-grid">
        <div class="s7-page-error-code">
            <div class="s7-page-error-code-part">
                <span>4</span>
            </div>
            <div class="s7-page-error-code-part">
                <span>0</span>
            </div>
            <div class="s7-page-error-code-part">
                <span>3</span>
            </div>
        </div>
        <div class="s7-page-error-description">
            <div class="s7-page-error-description-row">
                <h2>{{ title }}</h2>
            </div>
            <div class="s7-page-error-description-row" *ngIf="!!description" [innerHTML]="description"></div>
            <div class="s7-page-error-description-row">
                <button class="btn btn-lg btn-primary" *ngIf="!!buttonTitle" (click)="buttonClick()">{{ buttonTitle }}</button>
            </div>
            <div class="s7-page-error-description-row">
                {{ 'shared:accessDeniedPage.default.needHelp' | i18next }}
                <a class="link" href="mailto:vm@s7.ru">{{ 'shared:accessDeniedPage.default.write' | i18next }}</a>
            </div>
        </div>
    </div>
</div>
